import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { headerAnimationDataProvider as store } from "./header-animation-data-provider";
import headerMobileAnimation from "./header-mobile-animation";
import headerDesktopAnimation from "./header-desktop-animation";
import initDestinationNavbar from "./destination-navbar-animation";

export const headerMasterAnimation = () => {
  gsap.registerPlugin(ScrollTrigger);

  const masterStickyAnimationTl = gsap.timeline({
    repeat: 0,
    paused: true,
  });

  masterStickyAnimationTl
    .addLabel("startToSticky", 0)
    .addLabel("stickyToScrollUp", 0.5)
    .addLabel("scrollUpToInitialPosition", 1)
    .addLabel("backToTop", 1.5);

  return masterStickyAnimationTl;
};

const animationController = () => {
  let nextLabel = store.currentState.TIMELINE.nextLabel();
  let tweenInProgressTl = false;
  let positionFromTop = 0;

  // Init position if page refreshed mid-page
  positionFromTop = window.pageYOffset;
  if (positionFromTop > store.constants.STICKY_THRESHOLD) {
    store.currentState.TIMELINE.seek("stickyToScrollUp");
  }

  ScrollTrigger.observe({
    type: "wheel, touch, scroll",
    onDown: () => {
      // This animates the header to sticky on scroll down
      if (
        (nextLabel === "stickyToScrollUp" || nextLabel === "backToTop" || nextLabel === undefined) &&
        store.constants.STICKY_THRESHOLD <= positionFromTop &&
        !tweenInProgressTl
      ) {
        store.currentState.TIMELINE.tweenTo("stickyToScrollUp", {
          ease: "power1.inOut",
          duration: 0.45,
          onStart: () => {
            tweenInProgressTl = true;
            document.dispatchEvent(new Event("toStickyToScrollDownStarted"));
          },
          onComplete: () => {
            tweenInProgressTl = false;
            document.dispatchEvent(new Event("toStickyToScrollDownEnded"));
          },
        });
      }
    },
    onUp: () => {
      // This animates the header to "scroll up" position on scroll up
      if (store.currentState.TIMELINE.currentLabel() === "stickyToScrollUp" && !tweenInProgressTl && !store.currentState.SCROLLTO_ACTIVE) {
        store.currentState.TIMELINE.tweenTo("scrollUpToInitialPosition", {
          ease: "power1.inOut",
          duration: 0.45,
          onStart: () => {
            tweenInProgressTl = true;
            document.dispatchEvent(new Event("toStickyOnScrollUpStarted"));
          },
          onComplete: () => {
            tweenInProgressTl = false;
            document.dispatchEvent(new Event("toStickyOnScrollUpEnded"));
          },
        });
      }

      // This animates the header to "back to top" position on scroll up when user reaches top of page
      if (
        positionFromTop < store.constants.STICKY_THRESHOLD &&
        store.currentState.TIMELINE.currentLabel() !== "backToTop" &&
        store.currentState.TIMELINE.currentLabel() !== "startToSticky" &&
        !tweenInProgressTl
      ) {
        store.currentState.TIMELINE.tweenTo("backToTop", {
          ease: "none",
          duration: 0.45,
          onStart: () => {
            tweenInProgressTl = true;
            document.dispatchEvent(new Event("toInitialPositionStarted"));
          },
          onComplete: () => {
            tweenInProgressTl = false;
            document.dispatchEvent(new Event("toInitialPositionEnded"));
          },
        });
      }
    },
    onChange: () => {
      positionFromTop = window.pageYOffset;
      nextLabel = store.currentState.TIMELINE.nextLabel();
    },
  });
};

export const initHeaderAnimation = () => {
  // document.addEventListener("DOMContentLoaded", () => {
  const tl = headerMasterAnimation();
  store.proxyCurrentState.TIMELINE = tl;
  initDestinationNavbar();
  headerMobileAnimation(tl);
  headerDesktopAnimation(tl);
  animationController(tl);
  // });
};

export default initHeaderAnimation;
